var _style, _circle, _path, _polygon, _polygon2, _circle2, _circle3, _circle4, _path2, _circle5, _path3, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDifferentialMolecules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2094E8;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 70,
    cy: 431.2,
    r: 56.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.3,290.9c0,0-81,96.3-89.7,107c-6.1,7.6,6.6,17.3,11.7,12c9.5-10,93.6-106,93.6-106L176.3,290.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "291.7,151.8 231.6,222.9 249.4,237.2 310.5,166.7 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "193,216.8 135.2,109.7 116.3,122.5 177.4,225.1 "
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 97.5,
    cy: 66.9,
    r: 64.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 327.8,
    cy: 127.5,
    r: 49.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 208.2,
    cy: 263.6,
    r: 52.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M354.9,253.5c0,0-102.4,0-110.4,0c-5,0-5.3,17.1,0,17.3c6.8,0.2,108.5,2.4,108.5,2.4L354.9,253.5z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 423,
    cy: 259.8,
    r: 75.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M386.7,442.2c0,0,30.4-122.4,33.2-134.4c1.8-7.5-14.2-11.6-16.6-3.7c-2.8,8.9-37.6,135.3-37.6,135.3 L386.7,442.2z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 370.5,
    cy: 472.1,
    r: 37.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifferentialMolecules);
export default __webpack_public_path__ + "static/media/DifferentialMolecules.b8315292afc6a7a1d807a690c60dc15b.svg";
export { ForwardRef as ReactComponent };